module.exports = __webpack_public_path__ + "static/INSTAGRAM-abcec1a430c7739c519a5e7f800e827e.mp4";